export const getLocale = (state) => state.getIn(['translate', 'locale'])
export const getToken = (state, id, module) => state.getIn(['ui', 'modules', module, 'workspace', id, 'token'], null)
export const getCustomData = (state, module, block, id) =>
    state.getIn(['ui', 'workspace', module, id, 'blocks', block, 'customData'])
export const getSessionId = (state) => state.getIn(['authorization', 'sessionId'])
export const getAuthorization = (state) => state.get('authorization')
export const getEntity = (state, module, id) => state.getIn(['ui', 'modules', module, 'workspace', id, 'entity'])
export const getActiveModule = (state) => state.getIn(['ui', 'moduleMenu', 'active'])
